import React from 'react'

const DefaultPage = React.lazy(() => import('./DefaultPage'))

export default {
  path: 'profile-summary',
  name: 'Profile Summary',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/new-profile/route.js